import { Store } from 'src/store';
import { EDITOR_CAPABILITY } from 'src/store/app/types';

/**
 * Whether the editor build actually loaded in the iframe supports a surface.
 *
 * The editor version is pinned per product by the integration layer, so a flag
 * being on says nothing about the editor being able to honour it. Without this
 * check a host-side flag can drive a message an older editor drops silently,
 * leaving the customer with a control that does nothing. Editors that predate
 * the capability list advertise nothing, so every capability reads as absent
 * and callers fall back.
 */
const hasEditorCapability = (store: Store, capability: EDITOR_CAPABILITY): boolean => (
  store.app.editorCapabilities.includes(capability)
);

export default hasEditorCapability;
